// extracted by mini-css-extract-plugin
module.exports = {"navBox":"navBox--1CjH5","tipsNavStatusBox":"tipsNavStatusBox--3c2Cp","tipsNavStatus":"tipsNavStatus--ORwls"};